import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { UntypedFormBuilder, NgForm } from '@angular/forms';
import { User } from 'src/app/model';
import { AuthProvider } from 'src/app/providers';
import {ActivatedRoute, Router} from '@angular/router';
import { CommonService } from 'src/app/services';
import {BusinessType} from '../../model/enums/business.type';
import {environment} from "../../../environments/environment";
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

declare var grecaptcha: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  @ViewChild('signUpForm') signUpForm: NgForm;

  userObject: User = new User();

  userTypeList: any[] = [];

  USER_TYPE: string;
  PROMO: string;
  OTHER_USER_TYPE: string;
  EMAIL: string = '';
  PASSWORD: string = '';
  showEnteredPassword: boolean = false;
  signUpDone: boolean = false;
  isDemo: boolean = false;
  error: string = '';
  captchaVisible: boolean = false;
  errorEmail: string = '';
  enumBusinessType = BusinessType;

  constructor(
    private authProvider: AuthProvider,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    window.scrollTo(0,0);

    /*if (environment.SHOW_DEBUG) {
      this.router.navigate(['/login']);
    }*/

    this.route.queryParams
      .subscribe(params => {
        if (params.email) {
          this.EMAIL = decodeURIComponent(params.email);
        }
        if (params?.userType) {
          this.USER_TYPE = params.userType;
        }
        if (params?.promo) {
          this.PROMO = params.promo;
          if(this.PROMO === 'PROMO2024' && !this.USER_TYPE){
            this.USER_TYPE = BusinessType.BUSINESS_OWNER;
          }
        }
      }
    );

    this.userTypeList.push({ key: 'SBA Lender', value: BusinessType.LENDER });
    this.userTypeList.push({ key: 'Small Business Development Center (SBDC)', value: BusinessType.SBDC });
    this.userTypeList.push({ key: 'Small Business Owner/Buyer', value: BusinessType.BUSINESS_OWNER });
    this.userTypeList.push({ key: 'Business Broker', value: BusinessType.BROKER });
    this.userTypeList.push({ key: 'Accounting Firm', value: BusinessType.ACCOUNTANT });
    this.userTypeList.push({ key: 'Other (Specify)', value: BusinessType.OTHER });

    // Clean up Local Storage
    localStorage.removeItem(environment.TOKEN_NAME);
  }

  /**
   * @description Change form view
   */
  toggleForm(): void {
    this.signUpDone = !this.signUpDone;
    this.EMAIL = '';
    this.PASSWORD = '';
  }

  /**
   * @description click on sign up page
   */
  signUp() {
    let params = {
      USER_TYPE: this.USER_TYPE,
      EMAIL: this.EMAIL,
      PASSWORD: this.PASSWORD,
      OTHER_DESC: null,
      PROMO: this.PROMO
    };

    if (this.USER_TYPE === BusinessType.OTHER || this.USER_TYPE === BusinessType.LENDER)
      params.OTHER_DESC = this.OTHER_USER_TYPE;

    if (this.signUpForm.valid) {
      this.error = '';
      this.authProvider.signUp(params).subscribe((resp) => {
        if (resp.success) {
          this.isDemo = resp?.result?.DEMO;
          this.signUpDone = true;
        } else {
          this.captchaVisible = resp.captcha;
          this.errorEmail = this.EMAIL;
          this.error = resp.error.txt;
          if (this.captchaVisible) {
            grecaptcha.reset();
          }
        }
      });
    } else {
      this.signUpForm.control.markAllAsTouched();
    }
  }

  public resolved(captchaResponse: string): void {
    // blank
  }

  /**
   * @description Remove error message
   */
  removeErrorMsg(): void {
    if (this.error && this.errorEmail !== this.EMAIL) {
      this.error = '';
    }
  }
}
